import { styled } from 'styled-components';

type ExtensionProps = {
  'data-background-color': string;
};

export const Wrapper = styled.div`
  padding-right: var(--spacing-small);
  position: relative;
`;

export const Extension = styled.div<ExtensionProps>`
  /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
  background-color: ${props => props['data-background-color']};
  border-radius: var(--border-radius-tiny);
  bottom: 0;
  color: var(--color-text-alt);
  font-size: var(--preferences-file-icon-extension-font-size);
  font-weight: var(--font-weight-file-icon);
  padding: var(--preferences-file-icon-extension-padding);
  position: absolute;
  right: 0;
  text-transform: uppercase;
  transform: translate(-10%, -35%);
  user-select: none;
`;
